import Message from 'formvalidation/plugins/Message';
import Trigger from 'formvalidation/plugins/Trigger';
import SubmitButton from 'formvalidation/plugins/SubmitButton';

import ValidationUtils from '../../utils/validation';

const getValidationRules = (
	universityCallback = () => true,
	duplicateEmailErrorMessage,
	emailCheckApiFailErrorMessage
) => ({
	fields: {
		firstName: {
			validators: {
				notEmpty: {
					message: 'Please enter a first name'
				},
				stringLength: {
					min: 2,
					message: 'First name must be 2 or more letters'
				},
				regexp: {
					regexp: /^[a-zA-Z-' ]+$/,
					message: 'Please enter a first name that contains only letters'
				}
			}
		},
		lastName: {
			validators: {
				notEmpty: {
					message: 'Please enter a last name'
				},
				stringLength: {
					min: 2,
					message: 'Last name must be 2 or more letters'
				},
				regexp: {
					regexp: /^[a-zA-Z-' ]+$/,
					message: 'Please enter last name that contains only letters'
				}
			}
		},
		emailAddress: {
			validators: {
				notEmpty: {
					message: 'Please enter an email address'
				},
				regexp: {
					regexp: /^[a-zA-Z0-9](?!.*[._%+-]{2})[a-zA-Z0-9._%+-]*@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/i,
					message: 'Please enter a valid email address'
				},
				emailExists: {
					message: duplicateEmailErrorMessage
				},
				errorCheckingEmail: {
					message: emailCheckApiFailErrorMessage
				}
			}
		},
		gender: {
			validators: {
				notEmpty: {
					message: 'Please select a gender'
				}
			}
		},
		universityStudent: {
			validators: {
				notEmpty: {
					message: 'Please select if you are currently studying at university'
				}
			}
		},
		university: {
			validators: {
				callback: {
					message: 'Please search and select a university',
					callback: universityCallback
				}
			}
		},
		graduationYear: {
			validators: {
				notEmpty: {
					message: 'Please select a graduation year'
				}
			}
		},
		mobilePhone: {
			validators: {
				regexp: {
					regexp: /^[0-9]{10,13}$/,
					message: 'Please enter a valid mobile phone number (10-13 digits only, no letters or special characters)'
				},
				callback: {
					message: 'Please enter a valid mobile phone number (numbers only)',
					callback: (value) => {
						// Additional check to ensure value contains only digits
						// This handles cases where type="number" allows scientific notation
						// Skip validation if value is empty - field is optional
						if (!value || typeof value !== 'string') {
							return { valid: true };
						}
						// Remove any whitespace and check if it's all digits
						const cleanedValue = value.trim().replace(/\s/g, '');
						if (!/^[0-9]+$/.test(cleanedValue)) {
							return { valid: false };
						}
						if (cleanedValue.length < 10 || cleanedValue.length > 13) {
							return { valid: false };
						}
						return { valid: true };
					}
				}
			}
		}
	},
	plugins: {
		// Disable per-field events for `university`, `graduationYear`, and `mobilePhone` so that their
		// validators run only during explicit form submission (not on input/change).
		trigger: new Trigger({
			event: {
				university: false,
				graduationYear: false,
				mobilePhone: false
			},
		}),
		// submitButton: new SubmitButton(), commented to fix issue with calling submit api twice
		message: new Message({
			clazz: 'lta-text-input__label-instruction',
			container: function(field, element) {
				let fieldType = element.getAttribute('type') || element.nodeName.toLowerCase();
				const inputWrapper = element.closest(ValidationUtils.getFieldWrapper(fieldType));
				return inputWrapper.querySelector('.lta-text-input--error');
			}
		}),
	}
});

export default getValidationRules;